// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "xyz.uniultra.wallet",
    name: "U2U Wallet",
    homepage: "https://wallet.uniultra.xyz/",
    image_id: "03bca3fc-c191-4877-592d-0b0d6557c900",
    app: {
        browser: null,
        ios: "https://apps.apple.com/vn/app/u2u-wallet/id6446194312?l=vi",
        android: "https://play.google.com/store/apps/details?id=org.u2u.wallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chrome.google.com/webstore/detail/u2u-wallet/ebjfhkbnnbjhcedilbedghedfgiaioed",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "u2uwc://",
        universal: "https://u2u.page.link/?apn=org.u2u.wallet&isi=6446194312&ibi=org.uniultra.wallet&link=https://uniultra.xyz/?referrer%3D",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map